import { UpdateState, UpdateStateItem } from 'app/shared/update-state-item';
import { Frequency, PlannedMaintenanceLibraryItem, MaintenanceType, ConditionForWork, FrequencyCalendarUnit } from '../planned-maintenance/planned-maintenance-library-item';

export class MaintenanceStrategyPlannedMaintenance implements UpdateStateItem {
  id: string;
  reference: string;
  title: string;
  type: MaintenanceType;
  conditionForWork: ConditionForWork;

  frequencyValue: number;
  interval: string;

  maintenanceStrategyId: string;
  plannedMaintenanceLibraryItemId: string;
  rowNumber: number;
  state: UpdateState = UpdateState.Unchanged;

  json() {
    return this;
  }

  loadFromJson(data: any) {
    this.id = data.id;
    this.reference = data.reference;
    this.title = data.title;
    this.type = data.type;
    this.conditionForWork = data.conditionForWork;

    this.maintenanceStrategyId = data.maintenanceStrategyId;
    this.plannedMaintenanceLibraryItemId = data.plannedMaintenanceLibraryItemId;
    this.rowNumber = data.rowNumber;

    this.loadFrequencyValue(data);
    this.loadInterval(data);
  }

  loadFromLibraryItem(libraryItem: PlannedMaintenanceLibraryItem) {
    this.reference = libraryItem.reference;
    this.title = libraryItem.title;
    this.type = libraryItem.maintenanceType;
    this.conditionForWork = libraryItem.conditionForWork;
    this.plannedMaintenanceLibraryItemId = libraryItem.id;
    this.rowNumber = libraryItem.rowNumber;

    this.loadFrequencyValue(libraryItem);
    this.loadInterval(libraryItem);
  }

  private loadFrequencyValue(data: any) {
    switch (data.frequency) {
      case Frequency.Calendar:
        this.frequencyValue = data.calendarValue;
        break;
      case Frequency.HoursRun:
        this.frequencyValue = data.hoursRunValue;
        break;
    }
  }

  private loadInterval(data: any) {
    switch (data.frequency) {
      case Frequency.Calendar:
        this.interval = FrequencyCalendarUnit[data.frequencyCalendarUnit];
        break;
      case Frequency.HoursRun:
        this.interval = 'Hours';
        break;
    }
  }
}
